module.exports = __webpack_public_path__ + "img/icon_place.201127c8.c5f3e628.svg";